import api from "./api";

export const getOverview = async (params) => {
    const { data } = await api.get("/marketing-dashboard/overview", { params });
    return data;
};

export const getLeadsBySource = async (params) => {
    const { data } = await api.get("/marketing-dashboard/sources", { params });
    return data;
};

export const getTimeline = async (params) => {
    const { data } = await api.get("/marketing-dashboard/timeline", { params });
    return data;
};

export const getSalesFunnel = async (params) => {
    const { data } = await api.get("/marketing-dashboard/funnel", { params });
    return data;
};

export const getMetrics = async (params) => {
    const { data } = await api.get("/marketing-dashboard/metrics", { params });
    return data;
};
